import React from 'react';
import PropTypes from 'prop-types';
import $t from 'lib/trackingService';
import { isLengthGreaterThan8, getFontSizeFromCharLength } from 'lib/fontBasedOnTextLength';
import classNames from 'classnames';

function ShopButton({
  additionalStyles,
  block,
  isWaffle,
  isBacon,
  listPrice,
  name,
  seller,
}) {
  const sellerFontSize = getFontSizeFromCharLength(seller);
  const bemElemVendorBtn = `${block}__vendorBtn`;
  const isLongerThan8Chars = isLengthGreaterThan8(seller);
  return (
    <div className={classNames('shop-button-info__shop', additionalStyles.shop)}>
      <button
        type="button"
        className={classNames(bemElemVendorBtn, additionalStyles.vendor, 'shop-button-info__vendor', {
          'shop-button-info__vendor-fit-text pl3-m': isLongerThan8Chars && isWaffle,
          'shop-button-info__vendor-fit-text': isLongerThan8Chars,
          'shop-button-info__bacon-button': isBacon,
          pl5: !isBacon,
        })}
        onClick={() => {
          $t('track', 'mbt_ecommerce_shop_button', {
            name,
            listPrice,
            seller,
          });
        }}
      >
        <span className={classNames(additionalStyles.icon, 'shop-button-info__icon icon icon-shop')} />
        <span className={classNames(additionalStyles.vendorName, sellerFontSize, 'shop-button-info__vendor-name')}>
          {seller}
        </span>
      </button>
    </div>
  );
}

ShopButton.propTypes = {
  additionalStyles: PropTypes.shape().isRequired,
  block: PropTypes.string.isRequired,
  isWaffle: PropTypes.bool.isRequired,
  isBacon: PropTypes.bool,
  listPrice: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  seller: PropTypes.string.isRequired,
};

ShopButton.defaultProps = {
  isBacon: false,
};

export default ShopButton;
